
//== Include Bootstrap.
//
//##

import 'bootstrap/js/src/base-component';
//import 'bootstrap/js/src/alert';
//import 'bootstrap/js/src/button';
//import 'bootstrap/js/src/carousel';
import 'bootstrap/js/src/collapse';
//import 'bootstrap/js/src/dropdown';
//import 'bootstrap/js/src/modal';
//import 'bootstrap/js/src/offcanvas';
//import 'bootstrap/js/src/popover';
//import 'bootstrap/js/src/scrollspy';
//import 'bootstrap/js/src/tab';
//import 'bootstrap/js/src/toast';
//import 'bootstrap/js/src/tooltip';



//== Include libraries.
//
//##

//import './Libraries/xxx'


//== Include stuff for extensions.
//
import '../../../../../datamints_formgenerator/Resources/Public/Scripts/_validation';
import '../../../../../datamints_formgenerator/Resources/Public/Scripts/_fieldCondition';

//import './Extensions/XXX'


//== Include stuff for content elements.
//
//##

//import './ContentElements/XXX'


//== Include stuff for parts of the websites.
//
//##

//import './Parts/XXX.js'
// import './Parts/navigationHover'
import './Parts/datamintsJobs'
import './Parts/lightbox'
import './Parts/featureFlags'


//== Write your own JavaScript stuff here.
//
//##

/*
window.addEventListener('DOMContentLoaded', () => {
 	console.log('Document is ready (global, footer).');
});
*/
